/**
 * 查询题目数量
 * @description 查询题目数量
 * @author hxliu
 * @date 2020-3-27
 */
import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizContainer,ossFileUtils } = framework_tool
import { ExamPreview } from '../../../../components'
import { modelUtils } from '@/utils';
let { Session } = utils_tool;
let { WizUpload, WizIcon, WizButton } = component_tool;
import { Spin } from 'antd'


class ChapterPreview extends WizContainer {

    componentName = 'ChapterPreview';

    constructor(props) {
        super(props);
        this.state = {
            chapterCategoryInfoList: props.chapterCategoryInfoList,
            questionIds: props.questionIds,
            title: props.title,
            score: props.score,
            description: props.description,
            data: null
        }
    }


    _componentDidMount() {
        this._reload(null, this.state);
    }

    propsAndStateOnChange = {
        chapterPreviewInfo: this._chapterPreviewInfo.bind(this),
    };
    _chapterPreviewInfo(nextProps, nextState) {
        let { chapterPreviewInfo } = nextProps
        if (chapterPreviewInfo && chapterPreviewInfo['success']) {
            let data = []
            if (chapterPreviewInfo['data']) {

                if (chapterPreviewInfo['data']['questions'] && chapterPreviewInfo['data']['questions'] instanceof Array) {
                    chapterPreviewInfo['data']['questions'].forEach((question, index) => {
                        //题目图片
                        if (question['img'] && question['img'] != '') {
                            log.info(`question['img']`,question['img'])
                            question['img'] = getOssFilePath(question['img']);
                        }else{
                            question['img'] = undefined
                        }
                        if (question['type'] === 1) {
                            question['correct'] = question['correct'].split(',').map(p => parseInt(p))
                        }
                        if (question['type'] === 2 || question['type'] === 0) {
                            question['correct'] = parseInt(question['correct'])
                        }
                        if (question['type'] === 3) {
                            let i = 0
                            let answerObj = JSON.parse(question['correct'])
                            let answer = new Array();
                            for (; ; i++) {
                              if (answerObj[i] === undefined) {
                                break;
                              } else {
                                answer[i] = new Array();
                                for (let j = 0; j < answerObj[i].length; j++) {
                                  answer[i][j] = answerObj[i][j]
                                }
                              }
                            }
                            question['correct'] = answer
                        }
                        let options = question['options']
                        if (options && options.length) {
                            options.forEach(o => {
                                if (o['fileUri'] && o['fileUri'] != '') {
                                    o['img'] = ossFileUtils.getOssUrlBySuffix(o['fileUri']);
                                }
                            });
                        }
                    })
                }


            }
            this.setState({
                data: chapterPreviewInfo['data'],
            });
        }
        return true
    }
    _reload(nextProps, nextState) {
        // let {categoryIds ,type,difficulty,order,total} = this.state.chapterCategoryInfoList
        let chapterCategoryInfoListValues = Object.assign([], nextState.chapterCategoryInfoList)
        let questionIdsValues = Object.assign([], nextState.questionIds)
        let paramsList = []
        let paramsQuestionIds = []
        chapterCategoryInfoListValues.forEach((val, index) => {
            let { categoryIds, type, difficulty, order, total } = val
            let params = { categoryId: categoryIds, order, total }
            if (type === 0 || type) {
                params = { ...params, type }
            }
            if (difficulty === 0 || difficulty) {
                params = { ...params, difficulty }
            }
            paramsList.push(params)
        });
        questionIdsValues.forEach((questionInfo, index) => {
            let { id, questionType } = questionInfo
            let params = { questionId: Math.abs(id), questionType }
            paramsQuestionIds.push(params)
        });
        this.doActions([
            {
                path: 'exam/chapterPreviewInfo',
                payload: {
                    key: 'chapterPreviewInfoKey',
                    apiParams: {
                        chapterCategoryInfoList: paramsList,
                        questionIds: paramsQuestionIds
                    }
                }
            },
        ]);
        return false;
    }
    _render() {
        const { data, title, score, description } = this.state
        let previewData = {}
        if (data) {
            let params = { ...data, title, score, description }
            if (data['questions'] && data['questions'] instanceof Array) {
                params = { ...params, size: data['questions'].length }
            }
            let parts = []
            parts.push(params)
            previewData = {
                parts
            }
        }
        let { examLoading } = this.props
        return (
            <Spin tip={'加载中'} spinning={examLoading}>
                <ExamPreview data={previewData} />
            </Spin>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { exam } = state;
    const chapterPreviewInfo = modelUtils.getModelEntity(exam, "chapterPreviewInfoKey");
    const load = modelUtils.getLoadingState(state, ['exam']);
    return {
        chapterPreviewInfo,
        ...load
    };
};

export default connect(mapStateToProps)(ChapterPreview);
